import { MenuItem } from 'src/features/layout/hooks/useSideMenuItems';

export function getAccessedItemsByKeys(
  menuItems: MenuItem[],
  keys: React.Key[]
) {
  const result: MenuItem[] = [];

  const findItemByKey = (
    items: MenuItem[],
    parentIcon: React.ReactNode | null
  ) => {
    items.forEach(item => {
      if (item && item.key && keys.includes(item.key)) {
        result.push({
          key: item.key,
          label: item.label,
          onClick: item.onClick,
          icon: item.icon || parentIcon,
        } as MenuItem);
      }

      if (item && item.children) {
        findItemByKey(item.children, item.icon || parentIcon);
      }
    });
  };

  findItemByKey(menuItems, null);

  return keys
    .map(key => result.find(item => item.key === key))
    .filter((item): item is MenuItem => item !== undefined);
}
